export default {
    items: [{
            name: 'Dashboard',
            url: '/supplier-portal/dashboard',
            icon: 'cui-dashboard',
            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Parts Replacement Records',
            url: '/supplier-portal/parts-replacement',
            icon: 'icon-folder-alt',
            badge: {
                variant: 'primary',
            },
        },
        /* {
            name: 'DORJ import log',
            url: '',
            icon: 'icon-layers',
            badge: {
                variant: 'primary',
            },
        },
        {
            name: 'LMU Invoice import log',
            url: '',
            icon: 'icon-basket-loaded',
            badge: {
                variant: 'primary',
            },
        }, */
        {
            name: 'Import Logs',
            url: '/supplier-portal/import-logs',
            icon: 'icon-layers',
            badge: {
                variant: 'primary',
            },
        },
        {
            name: 'Approval Request',
            url: '/supplier-portal/approval-request',
            icon: 'icon-layers',
            badge: {
                variant: 'primary',
            },
        },
        {
            name: 'Batch Submission Summary',
            url: '/supplier-portal/batch-submission-summary',
            icon: 'icon-layers',
            badge: {
                variant: 'primary',
            },
        },
        {
            name: 'LMU Settings',
            url: '',
            icon: 'icon-equalizer',
            badge: {
                variant: 'primary',
            },
            children: [
                {
                    name: 'Notifications',
                    url: '/supplier-portal/config-notification',
                    icon: 'icon-arrow-right',
                }
            ]
        },
    ]
}
